import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ElrondLogo = createIcon({
	displayName: "ElrondLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M102.3 25.4c-.5-.5-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.5.8 1 .8 1.7s-.3 1.2-.8 1.7c-.5.4-1.2.7-1.8.7-.7.1-1.4-.1-1.9-.7zM95.9 32.3c-.4-.5-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.4-1 .7-1.7.7s-1.2-.3-1.7-.7zM88.9 38.9c-.4-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.4.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.5-1 .7-1.7.7s-1.3-.3-1.7-.7zM82.2 45.6c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.4.8 1 .8 1.7s-.3 1.3-.8 1.7c-.5.5-1.2.7-1.8.7-.7 0-1.3-.1-1.9-.7zM75.8 52.3c-.5-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.4.7 1 .7 1.7s-.3 1.3-.7 1.7c-.4.5-1 .7-1.7.7-.6.1-1.3-.1-1.7-.7zM68.1 57.3c0-.7.3-1.2.7-1.7.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.4-1 .7-1.7.7s-1.2-.3-1.7-.7c-.5-.4-.7-1-.7-1.7zM55.6 72.1c-.4-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.5-1 .7-1.7.7-.6.1-1.2-.1-1.7-.7zM48.7 78.8c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.5.8 1 .8 1.7s-.3 1.2-.8 1.7-1.2.7-1.8.7c-.8.1-1.4-.2-1.9-.7zM42.2 85.6a2.413 2.413 0 0 1 0-3.4c.9-.9 2.5-.9 3.4 0 .4.4.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.5-1 .7-1.7.7s-1.1-.3-1.7-.7zM35.5 92.3c-.5-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.5.7 1 .7 1.7s-.3 1.3-.7 1.7c-.5.5-1 .7-1.7.7-.6 0-1.3-.2-1.7-.7zM28.6 99c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.5 0 .5.5.8 1 .8 1.7s-.3 1.3-.8 1.7c-.5.4-1.2.7-1.8.7-.7 0-1.3-.2-1.7-.7zM22 105.7c-.5-.5-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.4-1 .7-1.7.7-.5.1-1.1-.2-1.7-.7zM25.4 25.4c.4-.5.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7c.4.4 1 .7 1.7.7.7.1 1.3-.1 1.7-.7zM32.1 32.3c.5-.5.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.7 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7c.5.4 1.2.7 1.8.7.7-.1 1.4-.3 1.9-.7zM38.9 38.9c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.4-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7.6 0 1.2-.3 1.7-.7zM45.6 45.6c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0a2.413 2.413 0 0 0 0 3.4c.5.5 1 .7 1.7.7.6 0 1.2-.1 1.7-.7zM52.2 52.3c.5-.4.8-1 .8-1.7s-.3-1.2-.8-1.7c-.9-.9-2.6-.9-3.5 0-.5.4-.8 1-.8 1.7s.3 1.3.8 1.7c.5.5 1.2.7 1.8.7.6.1 1.3-.1 1.7-.7zM59.7 57.3c0-.7-.3-1.2-.7-1.7-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7c.4.4 1 .7 1.7.7s1.2-.3 1.7-.7c.5-.4.7-1 .7-1.7zM65.7 65.8c.5-.5.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7a2.413 2.413 0 0 0 3.4 0zM72.4 72.1c.5-.4.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.5 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7 1.2.7 1.8.7c.5.1 1.2-.1 1.7-.7zM79.2 78.8c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.5-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7.5.1 1.2-.2 1.7-.7zM85.9 85.6a2.413 2.413 0 0 0 0-3.4c-.9-.9-2.5-.9-3.4 0-.4.4-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7s1.2-.3 1.7-.7zM92.2 92.3c.5-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.5-.7 1-.7 1.7s.3 1.3.7 1.7c.5.5 1 .7 1.7.7.6 0 1.3-.2 1.7-.7zM99.3 99c.5-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.3.7 1.7c.4.4 1 .7 1.7.7s1.3-.2 1.7-.7zM106 105.7c.5-.5.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.5 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7c.5.4 1.2.7 1.8.7.5.1 1.1-.2 1.7-.7zM41.3 27.3c6.8-4.5 14.3-6.6 22.6-6.7 8.1 0 15.6 2.2 22.6 6.7l14.4-14.4C89.6 4.3 77.4 0 63.9 0S38 4.3 27 12.9l14.3 14.4zM26.9 86.4c-4.6-7-6.8-14.4-6.8-22.4 0-8.1 2.2-15.6 6.8-22.4L12.6 27.3C4.2 38.3 0 50.5 0 64.1 0 77.5 4.2 89.8 12.7 101l14.2-14.6zM86.4 100.7c-6.8 4.6-14.3 7-22.4 7.1-8.3 0-15.9-2.2-22.7-7l-14.4 14.3c11.1 8.7 23.5 13 37.1 12.9 13.5-.1 25.7-4.5 36.7-12.9l-14.3-14.4zM100.5 41.4c4.6 7 7 14.6 6.8 22.8-.1 8-2.4 15.3-6.8 22l14.4 14.3c8.5-11 12.9-23.2 12.9-36.6.1-13.6-4.2-26-12.9-37.1l-14.4 14.6zM115.5 105.2c5.5 0 10.1 4.5 10.1 10.1 0 5.5-4.5 10.1-10.1 10.1-5.5 0-10.1-4.5-10.1-10.1s4.5-10.1 10.1-10.1zM12.5 105.2c5.5 0 10 4.5 10 10.1 0 5.5-4.5 10.1-10 10.1s-10-4.5-10-10.1 4.5-10.1 10-10.1zM115.7 2.2c5.5 0 10 4.5 10 10.1s-4.5 10.1-10 10.1-10-4.5-10-10.1 4.5-10.1 10-10.1zM12.3 2.2c5.5 0 10.1 4.5 10.1 10s-4.5 10-10.1 10c-5.5 0-10.1-4.5-10.1-10s4.5-10 10.1-10z"
				className="st0"
			/>
		</g>
	),
});

export const MultiversXLogo = createIcon({
	displayName: "MultiversXLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M102.3 25.4c-.5-.5-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.5.8 1 .8 1.7s-.3 1.2-.8 1.7c-.5.4-1.2.7-1.8.7-.7.1-1.4-.1-1.9-.7zM95.9 32.3c-.4-.5-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.4-1 .7-1.7.7s-1.2-.3-1.7-.7zM88.9 38.9c-.4-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.4.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.5-1 .7-1.7.7s-1.3-.3-1.7-.7zM82.2 45.6c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.4.8 1 .8 1.7s-.3 1.3-.8 1.7c-.5.5-1.2.7-1.8.7-.7 0-1.3-.1-1.9-.7zM75.8 52.3c-.5-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.4.7 1 .7 1.7s-.3 1.3-.7 1.7c-.4.5-1 .7-1.7.7-.6.1-1.3-.1-1.7-.7zM68.1 57.3c0-.7.3-1.2.7-1.7.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.4-1 .7-1.7.7s-1.2-.3-1.7-.7c-.5-.4-.7-1-.7-1.7zM55.6 72.1c-.4-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.5-1 .7-1.7.7-.6.1-1.2-.1-1.7-.7zM48.7 78.8c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.7 0 .5.5.8 1 .8 1.7s-.3 1.2-.8 1.7-1.2.7-1.8.7c-.8.1-1.4-.2-1.9-.7zM42.2 85.6a2.413 2.413 0 0 1 0-3.4c.9-.9 2.5-.9 3.4 0 .4.4.7 1 .7 1.7s-.3 1.2-.7 1.7c-.5.5-1 .7-1.7.7s-1.1-.3-1.7-.7zM35.5 92.3c-.5-.4-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .4.5.7 1 .7 1.7s-.3 1.3-.7 1.7c-.5.5-1 .7-1.7.7-.6 0-1.3-.2-1.7-.7zM28.6 99c-.5-.4-.8-1-.8-1.7s.3-1.2.8-1.7c1-.9 2.6-.9 3.5 0 .5.5.8 1 .8 1.7s-.3 1.3-.8 1.7c-.5.4-1.2.7-1.8.7-.7 0-1.3-.2-1.7-.7zM22 105.7c-.5-.5-.7-1-.7-1.7s.3-1.2.7-1.7c.9-.9 2.5-.9 3.4 0 .5.5.7 1 .7 1.7s-.3 1.2-.7 1.7c-.4.4-1 .7-1.7.7-.5.1-1.1-.2-1.7-.7zM25.4 25.4c.4-.5.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7c.4.4 1 .7 1.7.7.7.1 1.3-.1 1.7-.7zM32.1 32.3c.5-.5.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.7 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7c.5.4 1.2.7 1.8.7.7-.1 1.4-.3 1.9-.7zM38.9 38.9c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.4-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7.6 0 1.2-.3 1.7-.7zM45.6 45.6c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0a2.413 2.413 0 0 0 0 3.4c.5.5 1 .7 1.7.7.6 0 1.2-.1 1.7-.7zM52.2 52.3c.5-.4.8-1 .8-1.7s-.3-1.2-.8-1.7c-.9-.9-2.6-.9-3.5 0-.5.4-.8 1-.8 1.7s.3 1.3.8 1.7c.5.5 1.2.7 1.8.7.6.1 1.3-.1 1.7-.7zM59.7 57.3c0-.7-.3-1.2-.7-1.7-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7c.4.4 1 .7 1.7.7s1.2-.3 1.7-.7c.5-.4.7-1 .7-1.7zM65.7 65.8c.5-.5.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.2.7 1.7a2.413 2.413 0 0 0 3.4 0zM72.4 72.1c.5-.4.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.5 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7 1.2.7 1.8.7c.5.1 1.2-.1 1.7-.7zM79.2 78.8c.4-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.5-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7.5.1 1.2-.2 1.7-.7zM85.9 85.6a2.413 2.413 0 0 0 0-3.4c-.9-.9-2.5-.9-3.4 0-.4.4-.7 1-.7 1.7s.3 1.2.7 1.7c.5.5 1 .7 1.7.7s1.2-.3 1.7-.7zM92.2 92.3c.5-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.4.5-.7 1-.7 1.7s.3 1.3.7 1.7c.5.5 1 .7 1.7.7.6 0 1.3-.2 1.7-.7zM99.3 99c.5-.4.7-1 .7-1.7s-.3-1.2-.7-1.7c-.9-.9-2.5-.9-3.4 0-.5.5-.7 1-.7 1.7s.3 1.3.7 1.7c.4.4 1 .7 1.7.7s1.3-.2 1.7-.7zM106 105.7c.5-.5.8-1 .8-1.7s-.3-1.2-.8-1.7c-1-.9-2.6-.9-3.5 0-.5.5-.8 1-.8 1.7s.3 1.2.8 1.7c.5.4 1.2.7 1.8.7.5.1 1.1-.2 1.7-.7zM41.3 27.3c6.8-4.5 14.3-6.6 22.6-6.7 8.1 0 15.6 2.2 22.6 6.7l14.4-14.4C89.6 4.3 77.4 0 63.9 0S38 4.3 27 12.9l14.3 14.4zM26.9 86.4c-4.6-7-6.8-14.4-6.8-22.4 0-8.1 2.2-15.6 6.8-22.4L12.6 27.3C4.2 38.3 0 50.5 0 64.1 0 77.5 4.2 89.8 12.7 101l14.2-14.6zM86.4 100.7c-6.8 4.6-14.3 7-22.4 7.1-8.3 0-15.9-2.2-22.7-7l-14.4 14.3c11.1 8.7 23.5 13 37.1 12.9 13.5-.1 25.7-4.5 36.7-12.9l-14.3-14.4zM100.5 41.4c4.6 7 7 14.6 6.8 22.8-.1 8-2.4 15.3-6.8 22l14.4 14.3c8.5-11 12.9-23.2 12.9-36.6.1-13.6-4.2-26-12.9-37.1l-14.4 14.6zM115.5 105.2c5.5 0 10.1 4.5 10.1 10.1 0 5.5-4.5 10.1-10.1 10.1-5.5 0-10.1-4.5-10.1-10.1s4.5-10.1 10.1-10.1zM12.5 105.2c5.5 0 10 4.5 10 10.1 0 5.5-4.5 10.1-10 10.1s-10-4.5-10-10.1 4.5-10.1 10-10.1zM115.7 2.2c5.5 0 10 4.5 10 10.1s-4.5 10.1-10 10.1-10-4.5-10-10.1 4.5-10.1 10-10.1zM12.3 2.2c5.5 0 10.1 4.5 10.1 10s-4.5 10-10.1 10c-5.5 0-10.1-4.5-10.1-10s4.5-10 10.1-10z"
				className="st0"
			/>
		</g>
	),
});

export const AdobexdLogo = createIcon({
	displayName: "AdobexdLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
				fill="#470137"
			/>
			<path
				d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
				fill="#FF61F6"
			/>
		</g>
	),
});

export const AtlassianLogo = createIcon({
	displayName: "AtlassianLogo",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
				fill="#2684FF"
			/>
			<path
				d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
				fill="#2684FF"
			/>
		</g>
	),
});

export const CartIcon = createIcon({
	displayName: "CartIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
		/>
	),
});

export const ClockIcon = createIcon({
	displayName: "ClockIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<g>
				<rect fill="none" height="24" width="24" />
			</g>
			<g>
				<g>
					<g>
						<path
							fill="currentColor"
							d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
						/>
					</g>
				</g>
			</g>
		</g>
	),
});
export const CreativeTimLogo = createIcon({
	displayName: "CreativeTimLogo",
	viewBox: "0 0 100 100",
	path: (
		<g
			xmlns="http://www.w3.org/2000/svg"
			width="50px"
			height="50px"
			version="1.1"
		>
			<g
				id="logo-creative-tim-black"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g
					id="icon"
					transform="translate(15.000000, 19.000000)"
					fill="currentColor"
					fillRule="nonzero"
				>
					<path
						d="M66.4346744,1.49018376e-13 L3.56968951,1.49018376e-13 C1.59820443,1.49018376e-13 -2.98036753e-13,1.59820443 -2.98036753e-13,3.56968951 L-2.98036753e-13,33.5035241 C-2.98036753e-13,35.4750091 1.59820443,37.0732136 3.56968951,37.0732136 L16.4677598,37.0732136 L16.4677598,66.4346744 C16.4666001,67.3810129 16.8417189,68.288989 17.5104719,68.9585615 C18.1792249,69.628134 19.0867408,70.0043639 20.03308,70.0043639 L49.9669146,70.0043639 C51.9383997,70.0043639 53.5366041,68.4061595 53.5366041,66.4346744 L53.5366041,37.0863214 L66.4346744,37.0863214 C67.3810136,37.0863221 68.2885296,36.7100915 68.9572826,36.0405189 C69.6260355,35.3709464 70.0011544,34.4629704 70,33.5166319 L70,3.56968951 C70.0011544,2.62335099 69.6260355,1.71537495 68.9572826,1.04580242 C68.2885296,0.37622988 67.3810136,1.49018376e-13 66.4346744,1.49018376e-13 Z M4.13769396,4.14206323 L32.9311503,4.14206323 L32.9311503,32.9355196 L4.13769396,32.9355196 L4.13769396,4.14206323 Z M49.3989102,65.86667 L20.6054538,65.86667 L20.6054538,37.0863214 L49.3989102,37.0863214 L49.3989102,65.86667 Z M65.8623007,32.9355196 L37.0688443,32.9355196 L37.0688443,4.14206323 L65.8623007,4.14206323 L65.8623007,32.9355196 Z"
						id="Shape"
					/>
					<path
						d="M23.6988934,23.3056595 C24.5142794,24.0708897 25.7898859,24.0506562 26.5805917,23.2599503 C27.3712976,22.4692445 27.3915311,21.193638 26.6263009,20.378252 L20.015603,13.767554 C19.2050095,12.9645312 17.8987889,12.9645312 17.0881954,13.767554 L10.4600204,20.378252 C9.90907005,20.8953125 9.68342943,21.6713831 9.87125954,22.4032422 C10.0590897,23.1351013 10.6305787,23.7065903 11.3624377,23.8944204 C12.0942968,24.0822505 12.8703675,23.8566099 13.387428,23.3056595 L18.5344222,18.1586654 L23.6988934,23.3056595 Z"
						id="Path"
					/>
					<path
						d="M46.3185783,23.3056595 L51.4655725,18.1586654 L56.6125667,23.3056595 C57.4279526,24.0708897 58.7035592,24.0506562 59.494265,23.2599503 C60.2849709,22.4692445 60.3052044,21.193638 59.5399742,20.378252 L52.9292763,13.767554 C52.1186828,12.9645312 50.8124622,12.9645312 50.0018687,13.767554 L43.3911708,20.378252 C42.6259406,21.193638 42.6461741,22.4692445 43.43688,23.2599503 C44.2275858,24.0506562 45.5031924,24.0708897 46.3185783,23.3056595 L46.3185783,23.3056595 Z"
						id="Path"
					/>
					<path
						d="M29.8508185,46.6987044 C29.0342976,45.9346441 27.7586832,45.9567597 26.9691385,46.7486649 C26.1795937,47.54057 26.1612859,48.8162446 26.9277802,49.6304812 L33.5384782,56.2368099 C33.9262423,56.6258256 34.452915,56.8444779 35.002182,56.8444779 C35.5514489,56.8444779 36.0781217,56.6258256 36.4658857,56.2368099 L43.0765837,49.6304812 C43.6002952,49.1075502 43.8052442,48.3449453 43.6142284,47.6299323 C43.4232126,46.9149194 42.8652519,46.3561259 42.1505246,46.1640439 C41.4357974,45.971962 40.6728876,46.1757734 40.1491761,46.6987044 L35.002182,51.8500678 L29.8508185,46.6987044 Z"
						id="Path"
					/>
				</g>
			</g>
		</g>
	),

	//   <chakra.svg
	//   height="50px"
	//   width="50px"
	//   viewBox="0 0 100 100"
	//   fill="none"
	//   xmlns="http://www.w3.org/2000/svg"
	//   color={fill}
	//   {...props}
	// >
	// </chakra.svg>
});

export const CreditIcon = createIcon({
	displayName: "CreditIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
		/>
	),
});

export const DashboardLogo = createIcon({
	displayName: "DashboardLogo",
	viewBox: "0 0 1000 257",
	path: (
		<svg width="998" height="257" viewBox="0 0 998 257" fill="none">
			<g clipPath="url(#clip0)">
				<path
					d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
					fill="currentColor"
				/>
				<path
					d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
					fill="currentColor"
				/>
				<path
					d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
					fill="currentColor"
				/>
				<path
					d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
					fill="currentColor"
				/>
				<path
					d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
					fill="currentColor"
				/>
				<path
					d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
					fill="currentColor"
				/>
				<rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
				<path
					d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
					fill="white"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear"
					x1="128.5"
					y1="0"
					x2="128.5"
					y2="257"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#7BCBD4" />
					<stop offset="1" stopColor="#29C6B7" />
				</linearGradient>
				<clipPath id="clip0">
					<rect width="997.832" height="257" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
});

export const DashboardLogoWhite = createIcon({
	displayName: "DashboardLogo",
	viewBox: "0 0 163.5 42",
	path: (
		<g fill="none">
			<path
				d="M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z"
				fill="#fff"
			/>
			<path
				d="M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z"
				fill="#3BCBBE"
			/>
		</g>
	),
});

export const DocumentIcon = createIcon({
	displayName: "DocumentIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
			/>
			<path
				fill="currentColor"
				d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
			/>
		</g>
	),
});

export const GlobeIcon = createIcon({
	displayName: "GlobeIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
				strokeWidth=".75"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109v18.28M20.39 11.249H2.11"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
		</g>
	),
});

export const HelpIcon = createIcon({
	displayName: "HelpIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
		/>
	),
});

export const HomeIcon = createIcon({
	displayName: "HomeIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
			/>
			<path
				fill="currentColor"
				d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
			/>
		</g>
	),
});

export const InvisionLogo = createIcon({
	displayName: "InvisionLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
				fill="#DC395F"
			/>
			<path
				d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
				fill="#fff"
			/>
		</g>
	),
});

export const JiraLogo = createIcon({
	displayName: "JiraLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
				fill="#2684FF"
			/>
			<path
				d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
				fill="url(#paint0_linear)"
			/>
			<path
				d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
				fill="url(#paint1_linear)"
			/>
		</g>
	),
});

export const MastercardIcon = createIcon({
	displayName: "MastercardIcon",
	viewBox: "0 0 24 24",
	path: (
		<svg
			width="24"
			height="20"
			viewBox="0 0 21 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
			<circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
		</svg>
	),
});

export const PayPalIcon = createIcon({
	displayName: "PayPalIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
			/>
			<path
				fill="currentColor"
				d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
			/>
		</g>
	),
});

export const PersonIcon = createIcon({
	displayName: "PersonIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
		/>
	),
});

export const ProfileIcon = createIcon({
	displayName: "ProfileIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path d="M0 0h24v24H0V0z" fill="transparent" />
			<path
				fill="currentColor"
				d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
			/>
		</g>
	),
});

export const RocketIcon = createIcon({
	displayName: "RocketIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
			/>
			<path
				fill="currentColor"
				d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
			/>
		</g>
	),
});

export const SettingsIcon = createIcon({
	displayName: "SettingsIcon",
	viewBox: "0 0 24 24",
	// path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
	path: (
		<g>
			<path d="M0,0h24v24H0V0z" fill="none" />
			<path
				fill="currentColor"
				d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
			/>
		</g>
	),
});

export const SlackLogo = createIcon({
	displayName: "SlackLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
			<path
				d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
				fill="#36C5F0"
			/>
			<path
				d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
				fill="#2EB67D"
			/>
			<path
				d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
				fill="#ECB22E"
			/>
			<path
				d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
				fill="#E01E5A"
			/>
		</g>
	),
});

export const SpotifyLogo = createIcon({
	displayName: "SpotifyLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
				fill="#2EBD59"
			/>
		</g>
	),
});

export const SupportIcon = createIcon({
	// Doesn't display the full icon without w and h being specified
	displayName: "BuildIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z"
		/>
	),
});

export const StatsIcon = createIcon({
	displayName: "StatsIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
		/>
	),
});

export const WalletIcon = createIcon({
	displayName: "WalletIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
			/>
			<path
				fill="currentColor"
				d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
			/>
		</g>
	),
});

export const VisaIcon = createIcon({
	displayName: "VisaIcon",
	viewBox: "0 0 24 24",
	path: (
		<svg
			width="26"
			height="20"
			viewBox="0 0 30 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
				fill="#4318FF"
			/>
		</svg>
	),
});
export const BillIcon = createIcon({
	displayName: "BillIcon",
	viewBox: "0 0 20 18",
	path: (
		<svg
			width="20"
			height="18"
			viewBox="0 0 20 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z"
				fill="#01B574"
			/>
		</svg>
	),
});

export const GraphIcon = createIcon({
	displayName: "GraphIcon",
	viewBox: "0 0 61 20",
	path: (
		<svg
			width="61"
			height="20"
			viewBox="0 0 61 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 8.2C1.70238 11.8 4.5 18.5 11 18C17.5 17.5 18.2786 1 29.6571 1C41.0357 1 41.0357 20.0286 60 3.57143"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
});

export const LightningIcon = createIcon({
	displayName: "LightningIcon",
	viewBox: "0 0 14 24",
	path: (
		<svg
			width="14"
			height="24"
			viewBox="0 0 14 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.74999 23.25H4.49999L5.74999 14.5H0.424988C0.424988 14.5 5.02499 6.425 8.24999 0.75H9.49999L8.24999 9.5H13.6L5.74999 23.25Z"
				fill="#09AD8F"
			/>
		</svg>
	),
});

export const CarIcon = createIcon({
	displayName: "CarIcon",
	viewBox: "0 0 22 19",
	path: (
		<svg
			width="22"
			height="19"
			viewBox="0 0 22 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.0733 1.34502C18.84 0.656687 18.1867 0.166687 17.4167 0.166687H4.58333C3.81333 0.166687 3.17167 0.656687 2.92667 1.34502L0.5 8.33335V17.6667C0.5 18.3084 1.025 18.8334 1.66667 18.8334H2.83333C3.475 18.8334 4 18.3084 4 17.6667V16.5H18V17.6667C18 18.3084 18.525 18.8334 19.1667 18.8334H20.3333C20.975 18.8334 21.5 18.3084 21.5 17.6667V8.33335L19.0733 1.34502ZM4.99167 2.50002H16.9967L18.2567 6.12835H3.73167L4.99167 2.50002ZM19.1667 14.1667H2.83333V8.33335H19.1667V14.1667Z"
				fill="white"
			/>
			<path
				d="M5.75 13C6.7165 13 7.5 12.2165 7.5 11.25C7.5 10.2835 6.7165 9.50003 5.75 9.50003C4.7835 9.50003 4 10.2835 4 11.25C4 12.2165 4.7835 13 5.75 13Z"
				fill="white"
			/>
			<path
				d="M16.25 13C17.2165 13 18 12.2165 18 11.25C18 10.2835 17.2165 9.50003 16.25 9.50003C15.2835 9.50003 14.5 10.2835 14.5 11.25C14.5 12.2165 15.2835 13 16.25 13Z"
				fill="white"
			/>
		</svg>
	),
});

export const LightningWhiteIcon = createIcon({
	displayName: "LightningWhiteIcon",
	viewBox: "0 0 18 24",
	path: (
		<svg
			width="18"
			height="24"
			viewBox="0 0 18 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8 -3.14722e-07L10.8 9.6L18 9.6L7.2 24L7.2 14.4L1.2779e-06 14.4L10.8 -3.14722e-07Z"
				fill="white"
			/>
		</svg>
	),
});

export const SlackWhiteIcon = createIcon({
	displayName: "SlackWhiteIcon",
	viewBox: "0 0 33 34",
	path: (
		<svg
			width="33"
			height="34"
			viewBox="0 0 33 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.099 0.0874023C10.2748 0.0887815 8.7985 1.60315 8.79985 3.46921C8.7985 5.33528 10.2762 6.84964 12.1004 6.85102H15.4009V3.47059C15.4023 1.60453 13.9246 0.0901608 12.099 0.0874023C12.1004 0.0874023 12.1004 0.0874023 12.099 0.0874023V0.0874023ZM12.099 9.1074H3.3003C1.4761 9.10878 -0.00158872 10.6231 -0.000240456 12.4892C-0.00293698 14.3553 1.47476 15.8696 3.29895 15.8724H12.099C13.9232 15.871 15.4009 14.3567 15.3996 12.4906C15.4009 10.6231 13.9232 9.10878 12.099 9.1074Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M33.0004 12.4892C33.0018 10.6231 31.5241 9.10878 29.6999 9.1074C27.8757 9.10878 26.398 10.6231 26.3993 12.4892V15.8724H29.6999C31.5241 15.871 33.0018 14.3567 33.0004 12.4892ZM24.2003 12.4892V3.46921C24.2017 1.60453 22.7253 0.0901608 20.9011 0.0874023C19.0769 0.0887815 17.5992 1.60315 17.6006 3.46921V12.4892C17.5979 14.3553 19.0756 15.8696 20.8998 15.8724C22.724 15.871 24.2017 14.3567 24.2003 12.4892Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.8994 33.9124C22.7236 33.911 24.2013 32.3966 24.2 30.5305C24.2013 28.6645 22.7236 27.1501 20.8994 27.1487H17.5989V30.5305C17.5975 32.3952 19.0752 33.9096 20.8994 33.9124ZM20.8994 24.891H29.6995C31.5237 24.8896 33.0014 23.3752 33.0001 21.5092C33.0027 19.6431 31.5251 18.1287 29.7009 18.126H20.9008C19.0766 18.1274 17.5989 19.6417 17.6002 21.5078C17.5989 23.3752 19.0752 24.8896 20.8994 24.891Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.21889e-07 21.509C-0.00134734 23.3751 1.47635 24.8895 3.30054 24.8908C5.12474 24.8895 6.60243 23.3751 6.60108 21.509V18.1272H3.30054C1.47635 18.1286 -0.00134734 19.6429 9.21889e-07 21.509ZM8.80009 21.509V30.529C8.79739 32.3951 10.2751 33.9095 12.0993 33.9122C13.9235 33.9109 15.4012 32.3965 15.3998 30.5304V21.5118C15.4025 19.6457 13.9248 18.1313 12.1006 18.1286C10.2751 18.1286 8.79874 19.6429 8.80009 21.509C8.80009 21.509 8.80009 21.5104 8.80009 21.509Z"
				fill="white"
			/>
		</svg>
	),
});

export const SpotifyWhiteIcon = createIcon({
	displayName: "SpotifyWhiteIcon",
	viewBox: "0 0 33 34",
	path: (
		<svg
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.5 0C7.387 0 0 7.387 0 16.5C0 25.613 7.387 33 16.5 33C25.613 33 33 25.613 33 16.5C33 7.38813 25.613 0.0011259 16.5 0ZM24.0671 23.7969C23.771 24.2833 23.1372 24.4353 22.653 24.1392C18.7788 21.7714 13.9014 21.2366 8.15824 22.5483C7.6043 22.6755 7.05261 22.3288 6.92651 21.7748C6.79928 21.2209 7.14493 20.6692 7.7 20.5431C13.9847 19.1076 19.3767 19.7257 23.726 22.3828C24.2101 22.6812 24.3644 23.3128 24.0671 23.7969ZM26.0859 19.3057C25.7132 19.9115 24.9206 20.1006 24.316 19.7291C19.8822 17.0033 13.1201 16.214 7.87451 17.806C7.19447 18.0121 6.47615 17.6281 6.26899 16.9492C6.06407 16.2692 6.448 15.552 7.12692 15.3448C13.1189 13.5265 20.569 14.407 25.6614 17.5369C26.2671 17.9096 26.4585 18.7011 26.0859 19.3057ZM26.2593 14.6265C20.9405 11.4684 12.1676 11.1779 7.08976 12.7181C6.27462 12.9658 5.41218 12.5053 5.16561 11.6902C4.91904 10.875 5.3784 10.0126 6.19468 9.76489C12.0234 7.99611 21.7118 8.33726 27.8344 11.9716C28.5673 12.4074 28.8083 13.3542 28.3737 14.0861C27.9402 14.8202 26.9911 15.0622 26.2593 14.6265Z"
				fill="white"
			/>
		</svg>
	),
});

export const AtlassianWhiteIcon = createIcon({
	displayName: "AtlassianWhiteIcon",
	viewBox: "0 0 33 34",
	path: (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.4845 14.7849C9.33764 14.5932 9.1208 14.4674 8.88145 14.4352C8.64209 14.4029 8.39971 14.4668 8.20734 14.6129C8.09417 14.7021 8.00288 14.816 7.94044 14.9459L0.0988266 30.6336C-0.0122374 30.8559 -0.0304801 31.1132 0.0481084 31.349C0.126697 31.5847 0.295685 31.7797 0.517928 31.8909C0.647834 31.9566 0.791452 31.9906 0.93703 31.9901H11.8624C12.0373 31.9946 12.2098 31.948 12.3587 31.8559C12.5076 31.7638 12.6264 31.6303 12.7006 31.4718C15.0586 26.6014 13.6292 19.1965 9.4845 14.7849Z"
				fill="url(#paint0_linear_217_1382)"
			/>
			<path
				d="M15.2489 0.509045C13.294 3.5172 12.1548 6.98187 11.9429 10.5631C11.731 14.1444 12.4537 17.7192 14.0401 20.9369L19.3076 31.4718C19.3854 31.6275 19.505 31.7585 19.653 31.8501C19.8011 31.9416 19.9717 31.9901 20.1458 31.9902H31.0689C31.1921 31.9905 31.3141 31.9664 31.428 31.9194C31.5418 31.8724 31.6453 31.8034 31.7324 31.7163C31.8195 31.6292 31.8886 31.5257 31.9356 31.4118C31.9826 31.298 32.0066 31.1759 32.0063 31.0527C32.0064 30.9075 31.9732 30.7641 31.9093 30.6336L16.8437 0.504633C16.7722 0.35366 16.6593 0.22609 16.5181 0.136757C16.377 0.0474239 16.2133 0 16.0463 0C15.8792 0 15.7156 0.0474239 15.5744 0.136757C15.4333 0.22609 15.3204 0.35366 15.2489 0.504633V0.509045Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_217_1382"
					x1="13.8012"
					y1="17.1826"
					x2="5.52068"
					y2="31.5247"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" stopOpacity="0.29" />
					<stop offset="0.92" stopColor="white" />
				</linearGradient>
			</defs>
		</svg>
	),
});

export const AdobeWhiteIcon = createIcon({
	displayName: "AdobeWhiteIcon",
	viewBox: "0 0 33 34",
	path: (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.84375 0H27.1562C30.3875 0 33 2.59829 33 5.81197V26.188C33 29.4017 30.3875 32 27.1562 32H5.84375C2.6125 32 0 29.4017 0 26.188V5.81197C0 2.59829 2.6125 0 5.84375 0Z"
				fill="white"
			/>
			<path
				d="M17.3523 8.41021L13.2273 15.1794L17.6273 22.3589C17.6548 22.4136 17.6685 22.4683 17.6548 22.523C17.641 22.5777 17.586 22.5367 17.5035 22.5504H14.3548C14.1348 22.5504 13.9835 22.5367 13.8873 22.4C13.5985 21.8256 13.296 21.2649 13.0073 20.6906C12.7185 20.1299 12.4023 19.5555 12.0723 18.9675C11.7423 18.3794 11.4123 17.7914 11.0823 17.1897H11.0548C10.766 17.7777 10.4498 18.3658 10.1335 18.9538C9.81728 19.5418 9.50103 20.1299 9.19853 20.7042C8.88228 21.2786 8.56603 21.8666 8.24978 22.4273C8.19478 22.5641 8.08478 22.5777 7.93353 22.5777H4.90853C4.85353 22.5777 4.81228 22.6051 4.81228 22.5367C4.79853 22.482 4.81228 22.4273 4.83978 22.3863L9.11603 15.4119L4.94978 8.39653C4.90853 8.34183 4.89478 8.28713 4.92228 8.25978C4.94978 8.21875 5.00478 8.20508 5.05978 8.20508H8.18103C8.24978 8.20508 8.31853 8.21875 8.37353 8.23243C8.42853 8.25978 8.46978 8.3008 8.51103 8.35551C8.77228 8.94354 9.07478 9.53157 9.39103 10.1196C9.72103 10.7076 10.0373 11.282 10.381 11.8564C10.711 12.4307 11.0135 13.0051 11.3023 13.5931H11.3298C11.6185 12.9914 11.921 12.4034 12.2235 11.829C12.526 11.2547 12.8423 10.6803 13.1585 10.1059C13.4748 9.53157 13.7773 8.94354 14.0798 8.38286C14.0935 8.32815 14.121 8.27345 14.1623 8.2461C14.2173 8.21875 14.2723 8.20508 14.341 8.21875H17.2423C17.311 8.20508 17.3798 8.2461 17.3935 8.31448C17.4073 8.32815 17.3798 8.38286 17.3523 8.41021Z"
				fill="#582CFF"
			/>
			<path
				d="M23.7045 22.8375C22.687 22.8512 21.6695 22.6461 20.7483 22.2221C19.882 21.8256 19.167 21.1692 18.672 20.3623C18.1633 19.5281 17.9158 18.4888 17.9158 17.2444C17.902 16.2324 18.1633 15.2341 18.672 14.3589C19.1945 13.47 19.9508 12.7315 20.8583 12.2392C21.8208 11.7059 22.9758 11.4461 24.337 11.4461C24.4058 11.4461 24.502 11.4461 24.6258 11.4598C24.7495 11.4734 24.887 11.4734 25.052 11.4871V7.16574C25.052 7.07001 25.0933 7.01531 25.1895 7.01531H27.9808C28.0495 7.00163 28.1045 7.05633 28.1183 7.11104C28.1183 7.12471 28.1183 7.13839 28.1183 7.13839V20.1572C28.1183 20.4033 28.132 20.6768 28.1458 20.9777C28.1733 21.2649 28.187 21.5384 28.2008 21.7709C28.2008 21.8666 28.1595 21.9486 28.0633 21.9897C27.3483 22.2905 26.592 22.5093 25.822 22.6461C25.1208 22.7692 24.4195 22.8375 23.7045 22.8375ZM25.052 20.1025V14.0854C24.9283 14.058 24.8045 14.0307 24.6808 14.017C24.5295 14.0033 24.3783 13.9897 24.227 13.9897C23.6908 13.9897 23.1545 14.0991 22.6733 14.3452C22.2058 14.5777 21.807 14.9196 21.5045 15.3572C21.202 15.7948 21.0508 16.3828 21.0508 17.0939C21.037 17.5726 21.1195 18.0512 21.2845 18.5025C21.422 18.8717 21.6283 19.1999 21.9033 19.4734C22.1645 19.7196 22.4808 19.911 22.8383 20.0204C23.2095 20.1435 23.5945 20.1982 23.9795 20.1982C24.1858 20.1982 24.3783 20.1845 24.557 20.1709C24.7358 20.1845 24.887 20.1572 25.052 20.1025Z"
				fill="#582CFF"
			/>
		</svg>
	),
});

export const InvisionWhiteIcon = createIcon({
	displayName: "InvisionWhiteIcon",
	viewBox: "0 0 33 34",
	path: (
		<svg
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.0085 0H2.99153C1.33934 0 0 1.33934 0 2.99153V30.0085C0 31.6607 1.33934 33 2.99153 33H30.0085C31.6607 33 33 31.6607 33 30.0085V2.99153C33 1.33934 31.6607 0 30.0085 0Z"
				fill="white"
			/>
			<path
				d="M11.0285 10.3841C12.1255 10.3841 13.0445 9.52433 13.0445 8.39743C13.0445 7.2713 12.1255 6.41162 11.0285 6.41162C9.9315 6.41162 9.01279 7.2713 9.01279 8.39743C9.01279 9.5242 9.9315 10.3841 11.0285 10.3841ZM6.84858 21.0215C6.73012 21.5255 6.67069 22.0698 6.67069 22.5137C6.67069 24.2631 7.61931 25.4244 9.63528 25.4244C11.3072 25.4244 12.6626 24.4316 13.6386 22.8284L13.0427 25.22H16.3626L18.2601 17.6095C18.7345 15.6826 19.6535 14.6824 21.047 14.6824C22.1438 14.6824 22.8256 15.3646 22.8256 16.4907C22.8256 16.8169 22.796 17.1723 22.6774 17.5579L21.699 21.056C21.5507 21.5601 21.4917 22.0643 21.4917 22.5383C21.4917 24.199 22.4697 25.4137 24.5153 25.4137C26.2644 25.4137 27.6577 24.2877 28.4285 21.5898L27.1242 21.0863C26.472 22.8937 25.9087 23.2205 25.4639 23.2205C25.0192 23.2205 24.782 22.9243 24.782 22.3317C24.782 22.0649 24.8416 21.7688 24.9303 21.4122L25.8791 18.0042C26.1162 17.2039 26.2053 16.4943 26.2053 15.8423C26.2053 13.2928 24.6636 11.9622 22.796 11.9622C21.047 11.9622 19.2681 13.5399 18.3789 15.2003L19.0309 12.22H13.9618L13.2502 14.8451H15.6219L14.1614 20.6923C13.0146 23.2418 10.9078 23.2832 10.6435 23.224C10.2093 23.126 9.93163 22.9611 9.93163 22.3971C9.93163 22.0716 9.99093 21.604 10.1392 21.0403L12.3628 12.22H6.73012L6.01855 14.8451H8.36039L6.84871 21.0215"
				fill="#582CFF"
			/>
		</svg>
	),
});

export const SimmmpleLogoWhite = createIcon({
	displayName: "SimmmpleLogoWhite",
	viewBox: "0 0 22 22",
	path: (
		<svg
			width="22px"
			height="22px"
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.7509 0.0229001L16.0242 0.0507784L16.2945 0.089609L16.5617 0.139392L16.8248 0.199131L17.0839 0.268827L17.3399 0.348479L17.5908 0.438088L17.8366 0.537654L18.0783 0.645185L18.315 0.762672L18.5465 0.88912L18.7729 1.02353L18.9932 1.16691L19.2074 1.31825L19.4155 1.47755L19.6174 1.64383L19.8122 1.81807L20.0009 1.99928L20.1825 2.18845L20.3569 2.3836L20.5231 2.58572L20.6822 2.79381L20.8342 3.00787L20.977 3.22891L21.1116 3.45492L21.2381 3.68592L21.3554 3.92288L21.4635 4.16483L21.5624 4.41075L21.6522 4.66166L21.7318 4.91754L21.8011 5.17641L21.8613 5.44026L21.9113 5.7071L21.95 5.97791L21.9776 6.25172L21.9949 6.52851L22 6.8073V15.1987L21.9949 15.4775L21.9776 15.7533L21.95 16.0271L21.9113 16.2969L21.8613 16.5637L21.8011 16.8266L21.7318 17.0864L21.6522 17.3413L21.5624 17.5922L21.4635 17.8382L21.3554 18.0801L21.2381 18.3161L21.1116 18.5471L20.977 18.7731L20.8342 18.9931L20.6822 19.2072L20.5231 19.4163L20.3569 19.6174L20.1825 19.8125L20.0009 20.0017L19.8122 20.1829L19.6174 20.3572L19.4155 20.5234L19.2074 20.6827L18.9932 20.8341L18.7729 20.9765L18.5465 21.1119L18.315 21.2373L18.0783 21.3548L17.8366 21.4633L17.5908 21.5619L17.3399 21.6515L17.0839 21.7322L16.8248 21.8019L16.5617 21.8616L16.2945 21.9104L16.0242 21.9492L15.7509 21.9781L15.4734 21.995L15.194 22H6.80603L6.52657 21.995L6.25016 21.9781L5.9758 21.9492L5.70552 21.9104L5.43829 21.8616L5.17515 21.8019L4.91609 21.7312L4.6611 21.6515L4.4102 21.5619L4.16337 21.4633L3.92165 21.3548L3.68503 21.2373L3.4535 21.1119L3.22809 20.9765L3.00779 20.8341L2.7936 20.6827L2.58452 20.5234L2.38257 20.3562L2.18776 20.1819L1.99907 20.0007L1.81752 19.8115L1.64312 19.6164L1.47687 19.4143L1.31776 19.2062L1.16681 18.9921L1.02299 18.7721L0.888363 18.5461L0.762911 18.3141L0.645619 18.0781L0.537506 17.8362L0.437552 17.5892L0.348818 17.3383L0.268243 17.0835L0.198887 16.8236L0.138711 16.5597L0.0897543 16.2929L0.0509968 16.0221L0.0224386 15.7493L0.00611961 15.4725L0 15.1927V6.8073L0.00611961 6.52851L0.0224386 6.25172L0.0509968 5.97791L0.0897543 5.7071L0.138711 5.44026L0.198887 5.17641L0.268243 4.91754L0.348818 4.66166L0.437552 4.41075L0.537506 4.16483L0.645619 3.92288L0.762911 3.68592L0.888363 3.45492L1.02299 3.22891L1.16681 3.00787L1.31776 2.79381L1.47687 2.58572L1.64312 2.3836L1.81752 2.18845L1.99907 1.99928L2.18776 1.81807L2.38257 1.64383L2.58452 1.47755L2.7936 1.31825L3.00779 1.16691L3.22809 1.02353L3.4535 0.88912L3.68503 0.762672L3.92165 0.645185L4.16337 0.537654L4.4102 0.438088L4.6611 0.348479L4.91609 0.268827L5.17515 0.199131L5.43829 0.139392L5.70552 0.089609L5.9758 0.0507784L6.25016 0.0229001L6.52657 0.00597393L6.80603 0H15.194L15.4734 0.00597393L15.7509 0.0229001ZM10.0198 13.2522L9.88827 13.2611L9.75874 13.2751L9.63023 13.295L9.50375 13.3199L9.37932 13.3497L9.25693 13.3856L9.13658 13.4254L9.01827 13.4702L8.90199 13.52L8.78878 13.5748L8.67863 13.6335L8.57051 13.6962L8.46648 13.7639L8.36449 13.8356L8.26555 13.9113L8.1707 13.9909L8.07891 14.0736L7.99017 14.1612L7.90552 14.2508L7.82494 14.3444L7.74743 14.442L7.67501 14.5425L7.60566 14.6451L7.5414 14.7516L7.48122 14.8602L7.42615 14.9717L7.37515 15.0862L7.32925 15.2027L7.28846 15.3221L7.25276 15.4426L7.22216 15.5661L7.19666 15.6915L7.17626 15.818L7.16198 15.9474L7.1528 16.0768L7.14974 16.2093V16.2202H11.8476L11.9802 16.2172L12.1117 16.2083L12.2423 16.1943L12.3698 16.1744L12.4962 16.1495L12.6217 16.1197L12.7441 16.0838L12.8644 16.044L12.9817 15.9992L13.098 15.9494L13.2112 15.8946L13.3214 15.8359L13.4295 15.7732L13.5345 15.7055L13.6355 15.6338L13.7344 15.5581L13.8293 15.4785L13.9221 15.3958L14.0098 15.3092L14.0945 15.2186L14.1751 15.125L14.2526 15.0274L14.325 14.9269L14.3943 14.8243L14.4586 14.7178L14.5188 14.6092L14.5739 14.4977L14.6248 14.3832L14.6707 14.2667L14.7115 14.1473L14.7472 14.0268L14.7789 13.9033L14.8044 13.7779L14.8237 13.6514L14.838 13.523L14.8472 13.3926L14.8503 13.2601V13.2502H10.1524L10.0198 13.2522ZM7.14974 9.52643L7.1528 9.66084L7.16198 9.79327L7.17626 9.92469L7.19666 10.0541L7.22216 10.1816L7.25276 10.308L7.28948 10.4315L7.33027 10.553L7.37719 10.6714L7.42819 10.7879L7.48326 10.9024L7.54344 11.0129L7.60872 11.1215L7.67807 11.227L7.75151 11.3296L7.82902 11.4281L7.9096 11.5237L7.99527 11.6163L8.08401 11.7049L8.17682 11.7896L8.27269 11.8712L8.37163 11.9479L8.47362 12.0205L8.57867 12.0892L8.68781 12.154L8.79898 12.2147L8.91219 12.2695L9.02846 12.3202L9.1478 12.366L9.26815 12.4079L9.39156 12.4437L9.51701 12.4746L9.64451 12.4995L9.77302 12.5194L9.90357 12.5343L10.0362 12.5423L10.1698 12.5453H14.8941V12.5343L14.8911 12.3999L14.8829 12.2675L14.8676 12.136L14.8482 12.0066L14.8217 11.8792L14.7911 11.7527L14.7554 11.6293L14.7136 11.5078L14.6677 11.3893L14.6167 11.2728L14.5606 11.1583L14.5004 11.0478L14.4351 10.9393L14.3668 10.8337L14.2934 10.7322L14.2159 10.6326L14.1343 10.537L14.0496 10.4444L13.9609 10.3558L13.8681 10.2712L13.7722 10.1905L13.6733 10.1129L13.5702 10.0402L13.4652 9.97149L13.3571 9.90677L13.2459 9.84703L13.1317 9.79127L13.0154 9.7405L12.8971 9.6947L12.7757 9.65387L12.6523 9.61703L12.5268 9.58717L12.4004 9.56128L12.2708 9.54136L12.1403 9.52643L12.0087 9.51846L11.8751 9.51548H7.14974V9.52643ZM10.0198 5.83255L9.88827 5.84151L9.75874 5.85545L9.63023 5.87536L9.50375 5.90025L9.37932 5.93012L9.25693 5.96597L9.13658 6.00579L9.01827 6.0506L8.90199 6.10038L8.78878 6.15514L8.67863 6.21388L8.57051 6.27661L8.46648 6.34432L8.36449 6.416L8.26555 6.49167L8.1707 6.57133L8.07891 6.65396L7.99017 6.74158L7.90552 6.83119L7.82494 6.92578L7.74743 7.02236L7.67501 7.12292L7.60566 7.22547L7.5414 7.33201L7.48122 7.44053L7.42615 7.55205L7.37515 7.66655L7.32925 7.78304L7.28846 7.90252L7.25276 8.02299L7.22216 8.14645L7.19666 8.2719L7.17626 8.39835L7.16198 8.52779L7.1528 8.65722L7.14974 8.78964V8.8006H11.8476L11.9802 8.79761L12.1117 8.78865L12.2423 8.77471L12.3698 8.7548L12.4962 8.72991L12.6217 8.70004L12.7441 8.66419L12.8644 8.62437L12.9817 8.57956L13.098 8.52978L13.2112 8.47502L13.3214 8.41627L13.4295 8.35355L13.5345 8.28584L13.6355 8.21416L13.7344 8.13849L13.8293 8.05883L13.9221 7.97619L14.0098 7.88957L14.0945 7.79897L14.1751 7.70538L14.2526 7.6078L14.325 7.50724L14.3943 7.40469L14.4586 7.29815L14.5188 7.18963L14.5739 7.07811L14.6248 6.96361L14.6707 6.84712L14.7115 6.72764L14.7472 6.60717L14.7789 6.48371L14.8044 6.35825L14.8237 6.23181L14.838 6.10337L14.8472 5.97294L14.8503 5.84051V5.83056H10.1524L10.0198 5.83255Z"
				fill="white"
			/>
		</svg>
	),
});
